import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LeadAutomationDashboard from '../configuracoes/LeadAutomationDashboard';

export default function LeadAutomationDashboardModal({
  pipelineId = null,
}) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="outline-primary"
        onClick={() => setShow(true)}
      >
        Ver monitoramento do atendimento
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="xl"
        centered
        scrollable
        fullscreen="lg-down"
        aria-labelledby="lead-automation-dashboard-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="lead-automation-dashboard-modal-title">
            Monitoramento do atendimento
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ background: '#f8fafc', padding: 20 }}>
          {show && (
            <LeadAutomationDashboard
              initialPipelineId={pipelineId}
            />
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
